import { createFetcher } from '@wui/common-library'

import { appBaseUrl, ensureAppBaseUrlReady } from '@/shared/utils/import-meta'

import { getCorrectUrl } from '../fetch'

export default createFetcher().create(async (url: string, args: unknown) => {
  const options = args as { body: string, headers: Record<string, unknown> }
  options.headers = {
    'Accept': 'application/json, text/plain',
    'Content-Type': 'application/json;charset=UTF-8',
  }

  await ensureAppBaseUrlReady()
  const base = appBaseUrl()
  const headers = Object.entries(options.headers || {}).filter(([, value]) => value !== undefined).map(([key, value]) => [key, String(value)])
  try {
    return import('@tauri-apps/plugin-http').then(({ fetch }) => fetch(getCorrectUrl(base, url), {
      headers: headers as [string, string][],
      method: 'POST',
      body: options.body,
    }))
  } catch (error) {
    throw error
  }
})
